<template>
  <el-container>
    <el-header ref="top1">
      <admin_header />
    </el-header>
    <el-main >
      <el-breadcrumb separator-class="el-icon-arrow-right" class="obpm-header-nav" ref="top2">
        <el-breadcrumb-item :to="{ path: '/home' }">{{$t('location')}}</el-breadcrumb-item>
        <el-breadcrumb-item>
          <template >
            <i @click="onBackSystem" style="font-style:normal;" class="pointer">{{$t('system_monitoring')}}</i>
          </template>
        </el-breadcrumb-item>
        <el-breadcrumb-item v-if="cpuVisible">{{$t('server_monitoring')}}</el-breadcrumb-item>

      </el-breadcrumb>
      
      <el-main v-if="!swaggerVisible && !onlineUserVisible && !cpuVisible && !jamenVisible" >
        <el-row justify="center" >
          <!-- <el-col :span="15"> -->
            <p class="textCen marginBot10">{{$t('server_monitoring')}}</p>
            <table style="border-collapse: collapse;margin:0 auto;" class="jamonList ">
              <tr >
                <td class="baseBorderAll ">Druid Monitor</td>
                <td class=" baseBorderAll ">{{$t('druid_Monitor')}}</td>
                <td class="baseBorderAll padding10">
                  <el-button type="primary" plain @click="druid" size="small">{{$t('enter')}}</el-button>
                  <!-- <a href="/obpm/core/monitor/druid/index.html"></a> -->
                </td>
              </tr>
              <tr>
                <td  class="baseBorderAll ">Jamon</td>
                <td class=" baseBorderAll">{{$t('jamon')}}</td>
                <td class="baseBorderAll padding10">
                  <!-- <a href="/obpm/core/jamon/menu.jsp">进入</a> -->
                  <el-button type="primary" plain @click="jamen" size="small">{{$t('enter')}}</el-button>

                </td>
              </tr>
              <tr>
                <td class="baseBorderAll ">Swagger2</td>
                <td class=" baseBorderAll">{{$t('swagger2')}}</td>
                <td  class="baseBorderAll padding10">
                  <el-button type="primary" plain @click="swaggerEnter" size="small">{{$t('enter')}}</el-button>
                </td>
              </tr>
              <tr>
                <td class="baseBorderAll ">web-services</td>
                <td class=" baseBorderAll">{{$t('web_services')}}</td>
                <td class="baseBorderAll padding10">
                  <!-- <a href="/obpm/servlet/AdminServlet">进入</a> -->
                  <el-button type="primary" plain @click="webServices" size="small">{{$t('enter')}}</el-button>
                </td>
              </tr>
              <tr>
                <td class="baseBorderAll ">OnlineUsers</td>
                <td class=" baseBorderAll">{{$t('onlineUsers')}}</td>
                <td class="baseBorderAll padding10">
                  <el-button type="primary" plain @click="onlineUserEnter" size="small">{{$t('enter')}}</el-button>
                </td>
              </tr>
              <tr>
                <td class="baseBorderAll ">cpu/heap/RAM</td>
                <td class=" baseBorderAll">{{$t('server_monitoring')}}</td>
                <td class="baseBorderAll padding10">
                  <el-button type="primary" plain @click="cpuEnter" size="small">{{$t('enter')}}</el-button>
                </td>
              </tr>
            </table>

          <!-- </el-col> -->
        </el-row>
      </el-main>
      <swagger v-if="swaggerVisible"  @exit="onBackSystem" :height="height"/>
      <onlineUser v-if="onlineUserVisible" @exit="onBackSystem"/>
      <cpu v-if="cpuVisible" @exit="onCpuBack" :height="height"/>
      <jamenList v-if="jamenVisible"  @exit="onJamenBack" :height="height"/>
    </el-main>
    
    
  </el-container>
</template>

<script>
import admin_header from "@/components/admin_header.vue";

import swagger from "@/components/swagger.vue";
import onlineUser from "@/components/onlineUser.vue";
import cpu from "@/components/cpu.vue";
import jamenList from "@/components/jamenList.vue";

export default {
  components: {
    admin_header,
    swagger,
    onlineUser,
    cpu,
    jamenList,

  },
  data() {
    return {
      swaggerVisible:false,
      onlineUserVisible:false,
      cpuVisible:false,
      jamenVisible:false,
      height:0,
    };
  },
  created() {
  },
  mounted(){
    var h = document.documentElement.clientHeight || document.body.clientHeight;
    this.height=h-this.$refs.top1.$el.getClientRects()[0].height-this.$refs.top2.$el.getClientRects()[0].height;
    
  },
  methods: {
    swaggerEnter(){
      this.swaggerVisible=true;
    },
    onlineUserEnter(){
      this.onlineUserVisible=true;
    },
    cpuEnter(){
      this.cpuVisible=true;

    },
    // onBack(){
    //   this.swaggerVisible=false;
    //   this.onlineUserVisible=false;
    // },
    onCpuBack(){
      this.cpuVisible=false;
    },
    druid(){
      let url = this.$api.getDebugUrl("/core/monitor/druid/index.html")
      window.location.href=url;

    },
    webServices(){
      let url = this.$api.getDebugUrl("/servlet/AdminServlet")
      window.location.href=url;

    },
    jamen(){
      this.jamenVisible=true;

    },
    onJamenBack(){
      this.jamenVisible=false;
    },
    onBackSystem(){
      this.swaggerVisible=false;
      this.onlineUserVisible=false;
      this.cpuVisible=false;
      this.jamenVisible=false;

    }
  }
};
</script>

<style>
</style>